import React from 'react';

import styled from 'styled-components';

interface Props {
  bottom?: number;
  color?: string;
}

export const StyledParagraph1 = styled.p<Props>`
  font-size: 32px;
  font-weight: 400;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledParagraph2 = styled.p<Props>`
  font-size: 20px;
  font-weight: 400;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledParagraph3 = styled.p<Props>`
  font-size: 16px;
  font-weight: 400;
  line-height: var(--lineHeightLarge);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledParagraph4 = styled.p<Props>`
  font-size: 14px;
  font-weight: 400;
  line-height: var(--lineHeightSmall);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledParagraph5 = styled.p<Props>`
  font-size: 12px;
  font-weight: 400;
  line-height: var(--lineHeightExtraLarge);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;
